import React from "react";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../action-type";
import { setDebateStatus } from "../../common/js/helpers";




export const getDebateDetails = ()=>async(dispatch)=>{
    try{
        const response = await axiosInstance.get("/join/mediator/debate");
        const {data} = response;
        dispatch({
            type:ActionTypes.DEBATE_DETAILS,
            payload:data
        })
    }
    catch(err){
        throw(err)
    }
}